<template>
  <div class="container">
    <div class="bjd" v-if="success">
      <div class="sub-title">禽舍情况说明</div>
      <div class="block">
        <div class="line-info">
          禽舍类型：鸡舍（{{ params.jlColumn + 1 }}走道）
        </div>
        <div class="line-info">
          禽舍规格：{{ bjd.base.qsGg }}
        </div>
        <div class="line-info">
          光照需求： {{ params.lightSpec }}W LED球泡照明，亮度均匀稳定
        </div>
      </div>


      <div class="sub-title">方案说明</div>
      <div class="block">
        <div class="line-info">
          根据现有条件，结合 LED 灯产品的光照特点，为保证最佳的照明效果，给出以下建议照明方案：
        </div>
        <div class="line-info">
          1、推荐使用 {{ params.lightSpec }}W LED球泡产品
        </div>
        <div class="line-info">
          2、每条走道中央的上空布置灯线
        </div>
        <div class="line-info">
          3、同一灯线上灯泡搭配，{{ bjd.base.fa }}
        </div>
      </div>

      <div class="sub-title">方案汇总报价</div>
      <div class="item">
        <img class="light" src="@/assets/light2.png" alt=""/>
        <div class="item-content">
          <div class="it name">智能调光球泡</div>
          <div class="it">规格：{{ bjd.light.spec }}W</div>
          <div class="it">单价：{{ bjd.light.price }} 元</div>
          <div class="it">数量：{{ bjd.light.num }} 个</div>
          <div class="it">质保：2年</div>
        </div>
        <div class="price">￥{{ bjd.light.totalPrice }}</div>
      </div>

      <div class="item">
        <img class="img" src="@/assets/kzg.png" alt=""/>
        <div class="item-content">
          <div class="it name">{{ params.highMode && bjd.fg ? '调光控制柜-主柜' : '禽舍调光控制柜' }}</div>
          <div class="it">规格：{{ bjd.kzg.spec }}W</div>
          <div class="it">电源：{{ bjd.kzg.dySpec }}W x {{ bjd.kzg.dyCount }}</div>
          <div class="it" @click="changePrice('控制柜单价','kzg',bjd.kzg.price)">单价：{{ bjd.kzg.price }} 元</div>
          <div class="it">数量：{{ bjd.kzg.num }} 台</div>
          <div class="it">质保：2年</div>
        </div>
        <div class="price">￥{{ bjd.kzg.totalPrice }}</div>
      </div>

      <div class="item" v-if="bjd.fg && bjd.fg.total>0">
        <img class="img fg" src="@/assets/fg.png" alt=""/>
        <div class="item-content">
          <div class="it name">调光控制柜-副柜</div>
          <div class="it">规格：{{ bjd.fg.spec }}W</div>
          <div class="it">电源：{{ bjd.fg.dySpec }}W x {{ bjd.fg.dyCount }}</div>
          <div class="it" @click="changePrice('副柜单价','fg',bjd.fg.price)">单价：{{ bjd.fg.price }} 元</div>
          <div class="it">数量：{{ bjd.fg.num }} 台</div>
          <div class="it">质保：2年</div>
        </div>
        <div class="price">￥{{ bjd.fg.totalPrice }}</div>
      </div>

      <div class="item">
        <div class="xian-img">
          <img class="img2" src="@/assets/fx.png" alt=""/>
          <div class="zb">质保：3年</div>
        </div>
        <div class="xian-container">
          <div class="xian">
            <div class="fx">
              <div class="fx-item name">主线</div>
              <div class="fx-item">规格：{{ bjd.zx.spec }}米</div>
              <div class="fx-item">数量：{{ bjd.zx.num }}根 <span class="sp"
                                                                 @click="changePrice('主线单价','zx',bjd.zx.price)">单价：{{
                  bjd.zx.price
                }}元/米</span></div>
            </div>
            <div class="price">￥{{ bjd.zx.totalPrice }}</div>
          </div>

          <div class="line"></div>
          <div class="xian">
            <div class="fx">
              <div class="fx-item name">延长线{{ params.highMode ? '-上层' : '' }}</div>
              <div class="fx-item">规格：{{ bjd.ycx.spec }}</div>
              <div class="fx-item">数量：各1根 <span class="sp" @click="changePrice('延长线单价','ycx',bjd.ycx.price)">单价：{{
                  bjd.ycx.price
                }}元/米</span></div>
            </div>
            <div class="price">￥{{ bjd.ycx.totalPrice }}</div>
          </div>

          <template v-if="bjd.ycx2 && bjd.ycx2.total>0">
            <div class="line"></div>
            <div class="xian">
              <div class="fx">
                <div class="fx-item name">延长线-下层</div>
                <div class="fx-item">规格：{{ bjd.ycx2.spec }}</div>
                <div class="fx-item">数量：各1根 <span class="sp"
                                                      @click="changePrice('延长线单价','ycx',bjd.ycx2.price)">单价：{{
                    bjd.ycx2.price
                  }}元/米</span></div>
              </div>
              <div class="price">￥{{ bjd.ycx2.totalPrice }}</div>
            </div>
          </template>

          <div class="line"></div>
          <div class="xian">
            <div class="fx">
              <div class="fx-item name">副线1{{ params.highMode ? '-上层' : '' }}</div>
              <div class="fx-item">规格：{{ bjd.fx1.spec }}</div>
              <div class="fx-item">数量：{{ bjd.fx1.num }}根 <span class="sp"
                                                                  @click="changePrice('副线1单价','fx1',bjd.fx1.price)">单价：{{
                  bjd.fx1.price
                }}</span></div>
            </div>
            <div class="price">￥{{ bjd.fx1.totalPrice }}</div>
          </div>

          <template v-if="bjd.fx1_xc && bjd.fx1_xc.total>0">
            <div class="line"></div>
            <div class="xian">
              <div class="fx">
                <div class="fx-item name">副线1-下层</div>
                <div class="fx-item">规格：{{ bjd.fx1_xc.spec }}</div>
                <div class="fx-item">数量：{{ bjd.fx1_xc.num }}根 <span class="sp"
                                                                       @click="changePrice('副线1单价','fx1_xc',bjd.fx1_xc.price)">单价：{{
                    bjd.fx1_xc.price
                  }}</span></div>
              </div>
              <div class="price">￥{{ bjd.fx1_xc.totalPrice }}</div>
            </div>
          </template>

          <template v-if="bjd.fx2.total>0">
            <div class="line"></div>
            <div class="xian">
              <div class="fx">
                <div class="fx-item name">副线2{{ params.highMode ? '-上层' : '' }}</div>
                <div class="fx-item">规格：{{ bjd.fx2.spec }}</div>
                <div class="fx-item">数量：{{ bjd.fx2.num }}根 <span class="sp"
                                                                    @click="changePrice('副线2单价','fx2',bjd.fx2.price)">单价：{{
                    bjd.fx2.price
                  }}</span></div>
              </div>
              <div class="price">￥{{ bjd.fx2.totalPrice }}</div>
            </div>
          </template>

          <template v-if="bjd.fx2_xc.total>0">
            <div class="line"></div>
            <div class="xian">
              <div class="fx">
                <div class="fx-item name">副线2-下层</div>
                <div class="fx-item">规格：{{ bjd.fx2_xc.spec }}</div>
                <div class="fx-item">数量：{{ bjd.fx2_xc.num }}根 <span class="sp"
                                                                       @click="changePrice('副线2单价','fx2_xc',bjd.fx2_xc.price)">单价：{{
                    bjd.fx2_xc.price
                  }}</span></div>
              </div>
              <div class="price">￥{{ bjd.fx2_xc.totalPrice }}</div>
            </div>
          </template>

          <template v-if="bjd.fx3.total>0">
            <div class="line"></div>
            <div class="xian">
              <div class="fx">
                <div class="fx-item name">副线3</div>
                <div class="fx-item">规格：{{ bjd.fx3.spec }}</div>
                <div class="fx-item">数量：{{ bjd.fx3.num }}根 <span class="sp"
                                                                    @click="changePrice('副线3单价','fx3',bjd.fx3.price)">
                  单价：{{
                    bjd.fx3.price
                  }}</span></div>
              </div>
              <div class="price">￥{{ bjd.fx3.totalPrice }}</div>
            </div>
          </template>

        </div>
      </div>

      <div class="item">
        <div class="item-content">
          <div class="it zj">
            总价
            <span class="tip">（含运费 税:
              <template v-if="params.slMode===2">
                小规模
              </template>
               <template v-else-if="params.slMode===3">
                一般纳税人
              </template>
               <template v-else>
                不含税
              </template>
              ）</span>
          </div>
        </div>

        <div class="price">
          ￥
          <template v-if="params.slMode===2">
            {{ bjd.price.hs_3 }}
          </template>
          <template v-else-if="params.slMode===3">
            {{ bjd.price.hs_13 }}
          </template>
          <template v-else>
            {{ bjd.price.bhs }}
          </template>
        </div>

      </div>
      <!--   报价单下载信息   -->
      <div class="download-info" v-if="downloadInfo!=null">
        <img class="word" src="@/assets/word.png"/>
        <div class="info">
          <div class="name">{{ downloadInfo.name }}</div>
          <div class="opt">
            <van-button type="info" size="mini" @click="doDownload">下载报价单</van-button>
            <van-button style="margin-left: 8px" type="primary" size="mini"
                        class="copyClass" data-clipboard-action="copy" :data-clipboard-text="downloadInfo.url"
                        @click="copyLink">复制链接
            </van-button>
          </div>
        </div>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" @click="download">生成报价单</van-button>
      </div>
      <div class="bot"></div>
    </div>
    <van-loading v-else size="24px" vertical>计算中...</van-loading>
    <van-dialog v-model="showDialog" title="单价调整" show-cancel-button @confirm="dialogConfirm"
                :before-close="beforeClose"
    >
      <div class="price-dialog">
        <van-field
            v-model="dialogValue"
            :label="dialogTitle"
            type="number"
            :border="true"
            :placeholder="`请输入${dialogTitle}`"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {bjQuery, genBjd} from "@/api/bjd";
import clipboard from 'clipboard';

export default {
  name: "result",
  data() {
    return {
      success: false,
      params: {},
      bjd: {},
      dialogTitle: "",
      showDialog: false,
      dialogValue: "",
      fieldKey: "",
      downloadInfo: null,
      // downloadInfo: {
      //   name: "森迈光电-90米6层6列鸡舍照明报价和方案2022.12.13_0.docx",
      //   url: "https://smbucket-1306743120.cos.ap-guangzhou.myqcloud.com/file/森迈光电-90米6层6列鸡舍照明报价和方案2022.12.13_0.docx"
      // }
    }
  },
  created() {
    this.params = this.$route.params;
    this.doBjQuery()
  },
  methods: {
    // 查询报价单
    doBjQuery() {
      bjQuery(this.params).then((res) => {
        console.log(res)
        if (res.code) {
          this.bjd = res.data
          this.success = true
        } else {
          this.$toast(res.message);
        }
      })
    },
    download() {
      // this.$toast('功能开发中~')
      this.$toast.loading({
        message: '报价单生成中',
        forbidClick: true,
        duration: 0
      });
      genBjd(this.params).then(res => {
        console.log(res)
        this.$toast.clear(true)
        if (res.code && res.data) {
          // this.doDownload(res.data)
          this.downloadInfo = res.data
        }
      })
    },
    // 兼容android和ios的下载
    doDownload() {
      const src = this.downloadInfo.url
      if ((navigator.userAgent.indexOf('MSIE') >= 0) && (navigator.userAgent.indexOf('Opera') < 0)) {
        var fileURL = window.open(src, "_blank", "height=0,width=0,toolbar=no,menubar=no,scrollbars=no,resizable=on,location=no,status=no");
        fileURL.document.execCommand("SaveAs");
        fileURL.window.close();
        fileURL.close();
      } else if (window.navigator.msSaveBlob) {
        window.open(src);
      } else {
        var $a = document.createElement('a');
        $a.setAttribute("href", src);
        $a.setAttribute("download", "");
        var evObj = document.createEvent('MouseEvents');
        evObj.initMouseEvent('click', true, true, document.defaultView, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        $a.dispatchEvent(evObj);
      }
    },
    copyLink() {
      let clipboardUrl = new clipboard(".copyClass");
      clipboardUrl.on('success', () => {
        this.$toast("链接复制成功！");
      })
      clipboardUrl.on('error', () => {
        this.$toast("链接复制失败！");
      })
    },
// 显示修改价格弹窗
    changePrice(title, key, oldValue) {
      if (!this.params.smFlag) {
        console.log("非森迈用户，不能编辑单价")
        return
      }
      this.dialogTitle = title
      this.fieldKey = key
      this.dialogValue = oldValue
      this.showDialog = true
    },
// 确定修改价格
    dialogConfirm() {
      console.log('dialogConfirm')
      if (!this.dialogValue) {
        this.$toast("请输入单价")
        this.hasError = false
        return
      }
      this.hasError = true
      if (!this.params.price) {
        this.params.price = {}
      }
      this.params.price[this.fieldKey] = parseFloat(this.dialogValue)
      console.log("dialogConfirm:", this.params)
      this.doBjQuery()
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        done(this.hasError)
      } else {
        done()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 12px;
  width: 100vw;
  height: 100vh;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;

  .bjd {
    width: 100%;
    height: 100%;

    .title {
      font-size: 16px;
      font-weight: bold;
      width: 100%;
      text-align: center;
    }

    .sub-title {
      font-size: 16px;
      margin-bottom: 6px;
      font-weight: bold;
    }

    .block {
      font-weight: bold;
      background-color: #fff;
      padding: 8px;
      margin-bottom: 12px;
      border-radius: 5px;

      .line-info {
        font-size: 14px;
        font-weight: normal;
        margin: 4px 0;
        color: #747d8c;
      }
    }

    .item {
      background-color: #fff;
      padding: 12px;
      border-radius: 5px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;

      .img {
        width: 30%;
        margin-right: 6px;
      }

      .light{
        width: 23%;
        margin-right: 28px;
      }

      .fg {
        width: 23%;
        margin-right: 26px;
      }


      .item-content {
        flex: 1;
        font-size: 13px;

        .it {
          margin: 3px 0;

          .tip {
            font-size: 12px;
            color: #2c2c2c;
          }
        }

        .zj {
          font-size: 14px;
          font-weight: bold;
        }

        .name {
          font-size: 15px;
          font-weight: bold;
        }
      }

      .price {
        font-size: 18px;
        color: #27ae60;

      }

      .xian-img {
        width: 24%;
        display: flex;
        margin-right: 8px;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .img2 {
          width: 100%;
        }

        .zb {
          font-size: 14px;
          margin-top: 16px;
        }
      }

      .xian-container {
        flex: 1;
      }

      .line {
        width: 100%;
        height: 1px;
        background-color: #eeeeee;
      }

      .xian {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 4px;
        margin-bottom: 6px;

        .fx {
          flex: 1;
        }

        .fx-item {
          font-size: 13px;
          margin: 3px 0;

          .sp {
            margin-left: 10px;
          }
        }

        .name {
          font-size: 15px;
          font-weight: bold;
        }

        .price {
          font-size: 18px;
          color: #27ae60;
        }
      }
    }
  }
}

.price-dialog {
  padding: 24px;
}

.download-info {
  display: flex;
  padding: 12px;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 16px;

  .word {
    width: 22%;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;

    .name {
      font-size: 14px;
    }

    .opt {
      display: flex;
      margin-top: 6px;
    }
  }
}

.bot {
  height: 16px;
}
</style>
